import { jsPDF } from "jspdf";
import { CONTACT } from "@/data/site";

const FONTS = [
  ["CormorantGaramond-Light.ttf", "Cormorant", "normal"],
  ["PlusJakartaSans-Light.ttf", "Jakarta", "normal"],
  ["PlusJakartaSans-Medium.ttf", "Jakarta", "bold"],
  ["IBMPlexMono-Regular.ttf", "Plex", "normal"],
];
let fontCache;

const toBase64 = (buf) => {
  let s = "";
  const bytes = new Uint8Array(buf);
  for (let i = 0; i < bytes.length; i += 0x8000) s += String.fromCharCode.apply(null, bytes.subarray(i, i + 0x8000));
  return btoa(s);
};

const loadFonts = async () => {
  if (!fontCache) fontCache = Promise.all(FONTS.map(async ([file, name, style]) => [file, name, style, toBase64(await (await fetch(`/fonts/${file}`)).arrayBuffer())]));
  return fontCache;
};

export const C = { INK: "#161614", MUTED: "#78716c", RULE: "#d6d3d1", TERRACOTTA: "#B85C38", GOLD: "#C29B38", PAPER: "#FBFBF9", GREEN: "#2D6A4F" };
export const PAGE = { W: 210, H: 297, M: 18, R: 192 };

export const fmtLakh = (n) => (n >= 100 ? `₹${(n / 100).toFixed(2).replace(/\.?0+$/, "")} Cr` : `₹${n.toFixed(n < 10 ? 1 : 0).replace(/\.0$/, "")} L`);
export const inr = (n) => `₹${Math.round(n).toLocaleString("en-IN")}`;

// Carvings mark: gable roof with deep eaves over a plinth — the same house drafted on the site.
export const drawMark = (doc, x, y, s) => {
  doc.setDrawColor(C.INK); doc.setLineWidth(0.5); doc.setLineCap("round"); doc.setLineJoin("round");
  doc.line(x, y + s * 0.62, x + s * 0.5, y); doc.line(x + s * 0.5, y, x + s, y + s * 0.62);
  doc.line(x + s * 0.14, y + s * 0.62, x + s * 0.14, y + s * 0.98); doc.line(x + s * 0.86, y + s * 0.62, x + s * 0.86, y + s * 0.98);
  doc.line(x + s * 0.04, y + s * 0.98, x + s * 0.96, y + s * 0.98);
  doc.setDrawColor(C.TERRACOTTA); doc.line(x + s * 0.44, y + s * 0.98, x + s * 0.44, y + s * 0.76); doc.line(x + s * 0.44, y + s * 0.76, x + s * 0.56, y + s * 0.76); doc.line(x + s * 0.56, y + s * 0.76, x + s * 0.56, y + s * 0.98);
};

export const label = (doc, text, x, y, color = C.TERRACOTTA, align) => {
  doc.setFont("Plex", "normal"); doc.setFontSize(7); doc.setTextColor(color); doc.setCharSpace(1.2);
  doc.text(text, x, y, align ? { align } : undefined); doc.setCharSpace(0);
};

// A4 document with embedded fonts, paper fill, gold tape rule, branded header + footer.
export const newBrandedDoc = async (kind) => {
  const fonts = await loadFonts();
  const doc = new jsPDF({ unit: "mm", format: "a4" });
  fonts.forEach(([file, name, style, b64]) => { doc.addFileToVFS(file, b64); doc.addFont(file, name, style); });
  const { W, M, R } = PAGE;
  doc.setFillColor(C.PAPER); doc.rect(0, 0, W, PAGE.H, "F");
  doc.setFillColor(C.GOLD); doc.rect(0, 0, W, 1.2, "F");

  drawMark(doc, M, 16, 12);
  doc.setFont("Cormorant", "normal"); doc.setFontSize(26); doc.setTextColor(C.INK); doc.text("Carvings", M + 16, 25);
  doc.setTextColor(C.TERRACOTTA); doc.text(".", M + 16 + doc.getTextWidth("Carvings"), 25);
  label(doc, "ARCHITECTURE  ·  CARVINGS GROUP", M + 16, 30.5, C.MUTED);

  doc.setFont("Jakarta", "normal"); doc.setFontSize(8); doc.setTextColor(C.INK);
  [CONTACT.email, CONTACT.phoneDisplay, `Instagram ${CONTACT.instagramHandle}`].forEach((t, i) => doc.text(t, R, 18 + i * 4.4, { align: "right" }));
  doc.setTextColor(C.MUTED); doc.setFontSize(7);
  doc.text(doc.splitTextToSize(CONTACT.address, 62), R, 32, { align: "right" });
  doc.setDrawColor(C.RULE); doc.setLineWidth(0.3); doc.line(M, 42, R, 42);

  doc.setDrawColor(C.RULE); doc.setLineWidth(0.3); doc.line(M, 275, R, 275);
  drawMark(doc, M, 279, 7);
  doc.setFont("Plex", "normal"); doc.setFontSize(6.5); doc.setTextColor(C.MUTED);
  doc.text(`${kind} by Carvings Architecture  ·  ${CONTACT.email}  ·  ${CONTACT.phoneDisplay}  ·  instagram.com/gokul.kv`, M + 10, 283.5);
  doc.text("Ar. Nanda Gokul K.V · Carvings Group · Thalassery, Kerala", M + 10, 287.5);
  doc.setTextColor(C.TERRACOTTA); doc.text("Make your dream into reality.", R, 287.5, { align: "right" });
  return doc;
};
